var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMerchant({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.3334,
    cy: 16,
    r: 16,
    fill: "#1C6C2A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5333 11.7312C19.5333 13.4976 18.1008 14.9292 16.3333 14.9292C14.5659 14.9292 13.1333 13.4976 13.1333 11.7312C13.1333 9.96492 14.5659 8.53333 16.3333 8.53333C18.1008 8.53333 19.5333 9.96492 19.5333 11.7312Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6667 23.4569H11C11 22.6996 11 21.979 11 21.3265C11 19.5592 12.4327 18.1271 14.2 18.1271H18.4667C20.234 18.1271 21.6667 19.5592 21.6667 21.3265C21.6667 21.979 21.6667 22.6996 21.6667 23.4569Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchant);
export default __webpack_public_path__ + "static/media/merchant.1b3f9f8d4a650a263419ea2801635cb5.svg";
export { ForwardRef as ReactComponent };